import React from 'react'

function Profile() {
  return (
    <div>
      <h1>Note</h1>
      <h2>Read the basic instructions for best service experience:</h2>
      <h2>1)Choose the game according to topic you want to learn.</h2>
      <h2>2)Click Play on itch.io to play the game for any topic.</h2>
      <h2>3)For Registered users, data privacy will be ensured.</h2>
      <h2>4)Games can be choosen from course menu or from cards below.</h2>
      <h2>5)More games will be added soon.</h2>
      <center><h1>Thank you for using our services.</h1></center>

    </div>
    
  )
}

export default Profile